import { CheckCircle } from 'lucide-react';
import { Button } from '../UI/Button';
import { useWizard } from '../../context/WizardContext';

export function SuccessStep() {
  const { reset } = useWizard();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fade-in">
      <div className="text-center max-w-lg">
        <div className="mb-6">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          ¡Solicitud enviada con éxito!
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Tu solicitud de factura ha sido guardada correctamente. 
          El equipo de facturación la procesará en breve y te notificaremos por correo electrónico.
        </p>
        <div className="space-y-4">
          <p className="text-sm text-gray-500">
            <strong>ID de solicitud:</strong> {Date.now().toString(36).toUpperCase()}
          </p>
          <p className="text-sm text-gray-500">
            <strong>Fecha de envío:</strong> {new Date().toLocaleDateString('es-MX')}
          </p>
        </div>
        <div className="mt-10">
          <Button
            onClick={reset}
            variant="outline"
            className="w-full sm:w-auto"
          >
            Crear nueva solicitud
          </Button>
        </div>
      </div>
    </div>
  );
}